// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TDesktopMarkAsReadRequest,
  TDesktopMarkAsReadModel,
  IMappers,
  TDesktopMarkAsReadResponse,
  TDesktopMarkAsReadResponse_1,
  TDesktopMarkAsReadResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

export const defaultConfig: TDesktopMarkAsReadModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'notification-center',
  pathApi: '/v1/desktop/mark-as-read/',
  requestType: 'json',
} as TDesktopMarkAsReadModel;

export function createDesktopMarkAsReadModel(parameters: TDesktopMarkAsReadRequest): TDesktopMarkAsReadModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IDesktopMarkAsReadOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TDesktopMarkAsReadRequest;
}

export async function fetchDesktopMarkAsRead<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IDesktopMarkAsReadOptions<TResponse200, TResponse400>): Promise<
  TDesktopMarkAsReadResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createDesktopMarkAsReadModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TDesktopMarkAsReadResponse_1);
    }
    if (statusCode === 400) {
      return mappers[400](response as TDesktopMarkAsReadResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TDesktopMarkAsReadResponse;
}
